import script from "./review-status-compact.vue?vue&type=script&lang=ts&setup=true"
export * from "./review-status-compact.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__